
// 判断是否为有效的url
const isUrl = (val) => {
    /*eslint no-useless-escape:0*/
    let reg = /^(http|https):\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\’:+!]*([^<>\"\"])*$/;
    if(this.isString(val)){
        return reg.test(val);
    }else{
        return false;
    }
};

/**
 * ** checkType 数据类型校验  返回数据类型字符串 
 * @author : zhilichao
 * @param data  {all} 需要校验的数据
 * @returns 校验后的数据类型字符串(小写字符)
 * @description  checkType可以支持校验常见数据类型, 其中包含 null, undefined, object, array, string, number, boolean', function, regExp, symbol, /bigInt(后期扩展)/, date, formData, json
 * 
 * @extend 扩展checkType(1), 判断某个数据类型, 如果是当前数据类型则返回true, 如果不是当前数据类型则返回false
 * @param data {all} 需要校验的数据
 * @description  扩展函数名称: is + 数据类型, 示例: 1.字符串 checkType.isString('') 2.函数 checkType.isFunction(()=>{})
 * @returns 返回布尔 true / false
 * 
 * 
 * @extend 扩展checkType(2), 校验某个数据类型, 如果是当前数据类型则返回原数据,如果不是当前校验的数据类型则返回当前数据类型默认值
 * @param data {all} 需要校验的数据
 * @description  扩展函数名称: default + 数据类型, 示例: 1.字符串 checkType.defaultString(123) 2.函数 checkType.defaultFunction(()=>{})
 * @returns 
 * **/
const checkType = (()=>{
    const dataTypeStr = ['Null', 'Undefined', 'Object', 'Array', 'String', 'Number', 'Boolean', 'Function', 'RegExp', 'Symbol', 'Date', 'FormData'];
    const isJson = (str) => {
        if (typeof str === "string") {
            try {
                let obj = JSON.parse(str);
                return typeof obj == "object" && obj;
            } catch (error) {
                return false;
            }
        }else{
            return false;
        }
    };
    const type = (data) => {
        let typename = Object.prototype.toString.call(data);
        typename = typename.match(/\[object (.*?)\]/)[1].toLowerCase();
        if(typename == 'string'){
            typename = isJson(data) ? 'json' : typename;
        }
        return typename;
    };
    dataTypeStr.forEach((typename) => {
        type['is' + typename] = (data) => {
            return type(data) === typename.toLowerCase();
        };

        type['default' + typename]= (data) => {
            let name = type(data);
            if(name === typename.toLowerCase()){
                return data;
            }
            if(typename === 'Null'){
                return null;
            }
            if(typename === 'Undefined'){
                return undefined;
            }
            if(typename === 'Object'){
                return {};
            }
            if(typename === 'Array'){
                return [];
            }
            if(typename === 'String'){
                return '';
            }
            if(typename === 'Number'){
                return 0;
            }
            if(typename === 'Boolean'){
                return false;
            }
            if(typename === 'Function'){
                return () => {};
            }
            if(typename === 'RegExp'){
                return new RegExp();
            }
            if(typename === 'Symbol'){
                return Symbol();
            }
            if(typename === 'Date'){
                return new Date();
            }
            if(typename === 'FormData'){
                return new FormData();
            }
        }
    });
    type.isJson = isJson;
    type.defaultJson = (data) => {
        if(isJson(data)) {
            return data;
        } else {
            return '{}';
        }
    }

    return type;
})();

export {
    checkType,
    isUrl
}; 


// WEBPACK FOOTER //
// ./node_modules/@kkmh/utils/src/data-type-checking.js